import { useTranslations } from '@vocab/react';
import { Box, Text } from 'braid-design-system';
import type React from 'react';

import translations from './.vocab';
import loadingIcon from './four-pointed-loading-icon.gif';

import * as styles from './index.css';

const DotLoader = () => (
  <Box component="span" className={styles.loadingDot}>
    .
  </Box>
);

const DotsLoader = () => (
  <Box aria-hidden component="span" display="inlineBlock">
    <DotLoader />
    <DotLoader />
    <DotLoader />
  </Box>
);

const JobContentGenerationLoader = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      paddingY="xxlarge"
      width="full"
      height="full"
      className={styles.border}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingBottom="medium"
        height="full"
      >
        <Box
          component="img"
          src={loadingIcon}
          style={{ height: '47px', width: '47px' }}
          display="inlineBlock"
          marginBottom="gutter"
        />
        <Text>
          <Box component="span" className={styles.loadingText}>
            {t('job-content-generation-loader-text')}
          </Box>
          <DotsLoader />
        </Text>
      </Box>
    </Box>
  );
};

export const JobContentGenerationLoadingOverlay = ({
  children,
  isGenerating,
}: {
  children: React.ReactNode;
  isGenerating: boolean;
}) => (
  <Box position="relative" className={styles.wrapperLayout}>
    {isGenerating ? (
      <>
        <Box
          position="absolute"
          width="full"
          height="full"
          right={0}
          top={0}
          bottom={0}
          zIndex="modal"
          background="surface"
        >
          <JobContentGenerationLoader />
        </Box>
        {/* When the input field unmount, the focus will be automatically moved to the next input field on the page */}
        {/* This causes the page to auto-scroll down to keep the next input in view */}
        {/* So having an extra input here behind the loading overlay is to maintain the focus and prevent the page from scrolling down */}
        <Box padding="large">
          <input type="text" />
        </Box>
      </>
    ) : (
      children
    )}
  </Box>
);
